import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import ReactTable from 'Components/ReactTable/ReactTable';
import TableRow from '@material-ui/core/TableRow';
import BBPSAssured_LOGO from 'Assets/BBPS/BBPS-Assured.png';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@material-ui/core';

import {
    MONEY_TRANSFER_CODE,
    PAYOUT,
    DTH_BOOKING,
    PHONE_BOOKING,
    AEPS_CODE,
    PREPAID_ACTIVATION_CODE,
    MICRO_ATM_CODE,
    UPITRANSFER_CODE,
    E_KYC,
    OTT,
    CREDITCARDPAYMENT_CODE,
    VENDOR_PAY,
    CIBIL_SCORE_CODE,
    PAY_POINT_CODE
} from 'Components/Helper/Messages';

import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { withStyles } from '@material-ui/core/styles';
import { CIBILDownloadPDF } from 'Components/Api/CIBILScoreAPI';

const StyledTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold'
    }
}))(TableCell);
const ValueTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'green'
    }
}))(TableCell);

export function TransactionResponse({
    isOpen,
    isPrint,
    title,
    ServiceID,
    request,
    OkButtonTitle,
    OkButtonClick,
    PrintButtonTitle,
    PrintButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const [print, setPrint] = useState(isPrint);
    const classes = commonStyle();
    const [bgColor, setBGColor] = useState('');
    const [width, setWidth] = useState('xs');

    useEffect(() => {
        if (parseInt(ServiceID) === AEPS_CODE) {
            setWidth('md');
        }

        if (title === 'SUCCESS') {
            setBGColor('#42b86f');
            return;
        }

        if (title === 'FAILURE' || title === 'REFUND') {
            setBGColor('#ff0000');
            return;
        }

        if (title === 'PROCESS' || title === 'PENDING') {
            setBGColor('#f58220');
            return;
        }
    }, []);

    const handleOkButtonClick = () => {
        setOpen(false);
        OkButtonClick();
    };

    const handlePrintButtonClick = () => {
        setOpen(false);
        PrintButtonClick();
    };

    const handlePDFButtonClick = async () => {
        if (parseInt(ServiceID) === CIBIL_SCORE_CODE && request.TransactionID) {

            const requestObj = {
                CIBILScoreTransactionID: request.TransactionID,
                IsPDFDownload: true
            };
            const response = await CIBILDownloadPDF(JSON.stringify(requestObj));
            if (response.status && response.data) {
                const data = JSON.parse(response.data);
                if (data.ReportPath) {
                    let a = document.createElement('a');
                    a.href = data.ReportPath;
                    a.setAttribute('download', 'CIBIL_Score_Report.pdf');
                    a.setAttribute('target', '_blank');
                    a.click();
                    document.removeChild(a);
                }
            }

        }
    };

    const isPrintEnable = () => {
        if (
            parseInt(ServiceID) !== MONEY_TRANSFER_CODE &&
            parseInt(ServiceID) !== AEPS_CODE &&
            parseInt(ServiceID) !== PAYOUT &&
            parseInt(ServiceID) !== CREDITCARDPAYMENT_CODE &&
            parseInt(ServiceID) !== VENDOR_PAY &&
            parseInt(ServiceID) !== PAY_POINT_CODE
        )
            return false;

        if (title === 'FAILURE') return false;

        return true;
    };

    if (isOpen === undefined || isOpen === null || isOpen === false) {
        return null;
    }

    return (
        <Dialog
            open={open}
            onClose={() => {
                setOpen(false);
                OkButtonClick(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle
                id="alert-dialog-title"
                className={classes.title}
                style={{ background: bgColor }}
            >
                {title}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {parseInt(ServiceID) !== DTH_BOOKING &&
                        parseInt(ServiceID) !== PAYOUT &&
                        parseInt(ServiceID) !== VENDOR_PAY &&
                        parseInt(ServiceID) !== MONEY_TRANSFER_CODE &&
                        parseInt(ServiceID) !== MICRO_ATM_CODE &&
                        parseInt(ServiceID) !== AEPS_CODE &&
                        parseInt(ServiceID) !== PREPAID_ACTIVATION_CODE &&
                        parseInt(ServiceID) !== PHONE_BOOKING &&
                        parseInt(ServiceID) !== E_KYC &&
                        parseInt(ServiceID) !== OTT &&
                        parseInt(ServiceID) !== CREDITCARDPAYMENT_CODE &&
                        parseInt(ServiceID) !== CIBIL_SCORE_CODE &&
                        parseInt(ServiceID) !== PAY_POINT_CODE &&
                        parseInt(ServiceID) !== UPITRANSFER_CODE ? (
                        <RechargeResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === MONEY_TRANSFER_CODE ? (
                        <DMTTransferResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === PAY_POINT_CODE ? (
                        <PPITransferResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === CIBIL_SCORE_CODE ? (
                        <CIBILScoreResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === PAYOUT ? (
                        <PayoutResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === VENDOR_PAY ? (
                        <VendorPayResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === DTH_BOOKING ||
                        parseInt(ServiceID) === PHONE_BOOKING ? (
                        <OfflineResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === AEPS_CODE ? (
                        <AEPSResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === PREPAID_ACTIVATION_CODE ? (
                        <ActivationResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === E_KYC ? (
                        <EKYCResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === UPITRANSFER_CODE ? (
                        <UPITransferResponse request={request} />
                    ) : null}
                    {parseInt(ServiceID) === OTT ? (
                        <OTTTransferResponse request={request} />
                    ) : null}

                    {parseInt(ServiceID) === CREDITCARDPAYMENT_CODE ? (
                        <CreditCardResponse request={request} />
                    ) : null}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1}>
                    {isPrintEnable() ? (
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Button
                                onClick={() => handlePrintButtonClick()}
                                className={
                                    classes.CustomSecondaryButtonStylePopup
                                }
                            >
                                {PrintButtonTitle ? PrintButtonTitle : 'PRINT'}
                            </Button>
                        </Grid>
                    ) : (
                            <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
                    )}
                    {parseInt(ServiceID) === CIBIL_SCORE_CODE && title === 'SUCCESS' ? (
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Button
                                onClick={handlePDFButtonClick}
                                className={classes.CustomSecondaryButtonStylePopup}
                            >
                                Download PDF
                            </Button>
                        </Grid>
                    ) : (
                        <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
                    )}
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <Button
                            onClick={() => handleOkButtonClick()}
                            className={classes.CustomSecondaryButtonStylePopup}
                        >
                            {OkButtonTitle ? OkButtonTitle : 'OK'}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

const PayoutResponse = (request) => {
    let data = request.request;
    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        if (param.toUpperCase() === 'data not found'.toUpperCase()) return true;
        if (param.toUpperCase() === 'Paramnotmatched'.toUpperCase())
            return true;

        return false;
    };

    let rows = [];
    if (!isBlank(data.BeneficiaryName))
        rows.push(Data('Beneficiary', data.BeneficiaryName));

    if (!isBlank(data.Status)) rows.push(Data('Status', data.Status));

    if (!isBlank(data.TransactionID))
        rows.push(Data('TxnID', data.TransactionID));

    if (!isBlank(data.ConsumerNumber))
        rows.push(Data('AccountNo', data.ConsumerNumber));

    if (!isBlank(data.OpeningBalance.toString()))
        rows.push(Data('Op.Bal', data.OpeningBalance.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Amount', data.Amount.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Words', NumberToWord(data.Amount)));

    if (!isBlank(data.Commission.toString()))
        rows.push(Data('Commission', data.Commission.toString()));

    if (!isBlank(data.ClosingBalance.toString()))
        rows.push(Data('Cl.Bal', data.ClosingBalance.toString()));

    if (!isBlank(data.Message)) rows.push(Data('Message', data.Message));

    function Data(Parameter, Values) {
        return { Parameter, Values };
    }
    return (
        <>
            <Grid item xs={12}>
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.Parameter}>
                                    <StyledTableCell align="left">
                                        {row.Parameter}
                                    </StyledTableCell>
                                    <ValueTableCell align="left">
                                        {row.Values}
                                    </ValueTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </>
    );
};
const VendorPayResponse = (request) => {
    let data = request.request;
    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        if (param.toUpperCase() === 'data not found'.toUpperCase()) return true;
        if (param.toUpperCase() === 'Paramnotmatched'.toUpperCase())
            return true;

        return false;
    };

    let rows = [];
    if (!isBlank(data.BeneficiaryName))
        rows.push(Data('Beneficiary', data.BeneficiaryName));

    if (!isBlank(data.Status)) rows.push(Data('Status', data.Status));

    if (!isBlank(data.TransactionID))
        rows.push(Data('TxnID', data.TransactionID));

    if (!isBlank(data.ConsumerNumber))
        rows.push(Data('AccountNo', data.ConsumerNumber));

    if (!isBlank(data.OpeningBalance.toString()))
        rows.push(Data('Op.Bal', data.OpeningBalance.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Amount', data.Amount.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Words', NumberToWord(data.Amount)));

    if (!isBlank(data.Commission.toString()))
        rows.push(Data('Commission', data.Commission.toString()));

    if (!isBlank(data.ClosingBalance.toString()))
        rows.push(Data('Cl.Bal', data.ClosingBalance.toString()));

    if (!isBlank(data.Message)) rows.push(Data('Message', data.Message));

    function Data(Parameter, Values) {
        return { Parameter, Values };
    }
    return (
        <>
            <Grid item xs={12}>
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.Parameter}>
                                    <StyledTableCell align="left">
                                        {row.Parameter}
                                    </StyledTableCell>
                                    <ValueTableCell align="left">
                                        {row.Values}
                                    </ValueTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </>
    );
};

const RechargeResponse = (request) => {
    let data = request.request;
    const BBPSAssuredImage = () => {
        return (
            <img
                src={BBPSAssured_LOGO}
                height={80}
                width={80}
                style={{ float: 'right' }}
                alt="BBPS"
            />
        );
    };

    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        if (param.toUpperCase() === 'data not found'.toUpperCase()) return true;
        if (param.toUpperCase() === 'Paramnotmatched'.toUpperCase())
            return true;

        return false;
    };

    let rows = [];

    if (data.IsBBPS) {
        rows.push(Data('', <BBPSAssuredImage />));
    }

    if (!isBlank(data.Status)) rows.push(Data('Status', data.Status));


    if (!isBlank(data.TransactionID))
        rows.push(Data('TxnID', data.TransactionID));

    if (!isBlank(data.RefrenceID))
        rows.push(Data('Bharat Connect Txn ID', data.RefrenceID));

    if (!isBlank(data.ConsumerNumber))
        rows.push(Data('Number', data.ConsumerNumber));

    if (!isBlank(data.OpeningBalance.toString()))
        rows.push(Data('Op.Bal', data.OpeningBalance.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Amount', data.Amount.toString()));

    if (!isBlank(data.Commission.toString()))
        rows.push(Data('Comm.', data.Commission.toString()));

    rows.push(Data('Customer Convenience Fee', '0'));

    if (!isBlank(data.ClosingBalance.toString()))
        rows.push(Data('Cl.Bal', data.ClosingBalance.toString()));

    function Data(Parameter, Values) {
        return { Parameter, Values };
    }

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

const DMTTransferResponse = (request) => {
    let data = request.request;
    const rows = [
        DMTData('Status', data.Status),
        DMTData('RRN', data.TransactionID),
        DMTData('AccountNo', data.ConsumerNumber),
        DMTData('Beneficiary', data.BeneficiaryName),
        DMTData('Bank Name', data.BankName),
        DMTData('IFSC', data.IFSC),
        DMTData('Amount', data.Amount === '' ? '0' : data.Amount),
        DMTData('Message', data.Message)
    ];
    function DMTData(Parameter, Values) {
        return { Parameter, Values };
    }

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};
const PPITransferResponse = (request) => {
    let data = request.request;
    const rows = [
        DMTData('Status', data.Status),
        DMTData('RRN', data.TransactionID),
        DMTData('AccountNo', data.ConsumerNumber),
        DMTData('Beneficiary', data.BeneficiaryName),
        DMTData('Bank Name', data.BankName),
        DMTData('IFSC', data.IFSC),
        DMTData('Amount', data.Amount === '' ? '0' : data.Amount),
        DMTData('Message', data.Message)
    ];
    function DMTData(Parameter, Values) {
        return { Parameter, Values };
    }

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

const OfflineResponse = (request) => {
    let data = request.request;
    const rows = [
        OfflineData('Operator', data.OperatorName),
        OfflineData('Package', data.Name),
        OfflineData('Total Amount', data.Cost * data.Quantity)
    ];
    function OfflineData(Parameter, Values) {
        return { Parameter, Values };
    }
    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};
const AEPSResponse = (request) => {
    const [mainColumns, setMainColumns] = useState([]);
    let data = request.request;
    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        return false;
    };

    let rows = [];
    if (!isBlank(data.Status)) rows.push(Data('Status', data.Status));
    if (!isBlank(data.BankName)) rows.push(Data('BankName', data.BankName));
    if (!isBlank(data.BankRRN)) rows.push(Data('BankRRN', data.BankRRN));
    if (!isBlank(data.Amount)) rows.push(Data('Amount', data.Amount));
    if (!isBlank(data.AvailableBalance.toString()))
        rows.push(Data('AvailableBalance', data.AvailableBalance.toString()));
    if (!isBlank(data.Message)) rows.push(Data('Message', data.Message));
    if (!isBlank(data.ministatementStr))
        rows.push(Data('MiniStatements', data.ministatementStr));

    let transactions = data.ministatements;

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: 'Date',
            name: 'Date'
        });

        columns.push({
            label: 'Amount',
            name: 'Amount'
        });

        columns.push({
            label: 'TxnType',
            name: 'TxnType'
        });
        columns.push({
            label: 'Narration',
            name: 'Narration'
        });
        setMainColumns(columns);
    };

    function Data(Parameter, Values) {
        return { Parameter, Values };
    }

    useEffect(() => {
        createColumns();
    }, []);

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {transactions === undefined ||
                transactions === null ||
                transactions.length <= 0 ? null : (
                <ReactTable
                    data={transactions}
                    columns={mainColumns}
                    headerToolbar={false}
                    footerToolbar={false}
                />
            )}
        </Grid>
    );
};
const ActivationResponse = (request) => {
    let data = request.request;
    const rows = [
        OfflineData('Operator', data.OperatorName),
        OfflineData('ActivationType', data.ActivationType),
        OfflineData('AlternateNumber', data.AlternateNumber)
    ];
    function OfflineData(Parameter, Values) {
        return { Parameter, Values };
    }
    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

const UPITransferResponse = (request) => {
    let data = request.request;
    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        if (param.toUpperCase() === 'data not found'.toUpperCase()) return true;
        if (param.toUpperCase() === 'Paramnotmatched'.toUpperCase())
            return true;

        return false;
    };

    let rows = [];
    // rows.push(Data(data));

    if (!isBlank(data.BeneficiaryName))
        rows.push(Data('Beneficiary', data.BeneficiaryName));

    if (!isBlank(data.Status)) rows.push(Data('Status', data.Status));

    if (!isBlank(data.TransactionID))
        rows.push(Data('TxnID', data.TransactionID));

    if (!isBlank(data.ConsumerNumber))
        rows.push(Data('AccountNo', data.ConsumerNumber));

    if (!isBlank(data.OpeningBalance.toString()))
        rows.push(Data('Op.Bal', data.OpeningBalance.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Amount', data.Amount.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Words', NumberToWord(data.Amount)));

    if (!isBlank(data.Commission.toString()))
        rows.push(Data('Commission', data.Commission.toString()));

    if (!isBlank(data.ClosingBalance.toString()))
        rows.push(Data('Cl.Bal', data.ClosingBalance.toString()));

    if (!isBlank(data.Message)) rows.push(Data('Message', data.Message));

    function Data(Parameter, Values) {
        return { Parameter, Values };
    }
    return (
        <>
            <Grid item xs={12}>
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.Parameter}>
                                    <StyledTableCell align="left">
                                        {row.Parameter}
                                    </StyledTableCell>
                                    <ValueTableCell align="left">
                                        {row.Values}
                                    </ValueTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </>
    );
};
const EKYCResponse = (request) => {
    let data = request.request;

    const ProfileImage = (
        <img
            src={data.ProfileImage}
            height={100}
            width={100}
            alt={data.FullName}
        />
    );
    const rows = [
        EKYCData('Profile', ProfileImage),
        EKYCData('Name', data.FullName),
        EKYCData('Aadhaar', data.AadhaarNumber),
        EKYCData('Gender', data.Gender),
        EKYCData('Dob', data.Dob),
        EKYCData('Address', data.Address),
        EKYCData('Pin', data.Pin)
    ];
    function EKYCData(Parameter, Values) {
        return { Parameter, Values };
    }

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

const OTTTransferResponse = (request) => {
    let data = request.request;

    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        if (param.toUpperCase() === 'data not found'.toUpperCase()) return true;
        if (param.toUpperCase() === 'Paramnotmatched'.toUpperCase())
            return true;

        return false;
    };

    let rows = [];

    if (!isBlank(data.Status)) rows.push(Data('Status', data.Status));

    if (!isBlank(data.TransactionID))
        rows.push(Data('TxnID', data.TransactionID));

    if (!isBlank(data.ConsumerNumber))
        rows.push(Data('Number', data.ConsumerNumber));

    if (!isBlank(data.OpeningBalance.toString()))
        rows.push(Data('Op.Bal', data.OpeningBalance.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Amount', data.Amount.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Words', NumberToWord(data.Amount)));

    if (!isBlank(data.Commission.toString()))
        rows.push(Data('Commission', data.Commission.toString()));

    if (!isBlank(data.ClosingBalance.toString()))
        rows.push(Data('Cl.Bal', data.ClosingBalance.toString()));

    if (!isBlank(data.Message)) rows.push(Data('Message', data.Message));

    function Data(Parameter, Values) {
        return { Parameter, Values };
    }
    return (
        <>
            <Grid item xs={12}>
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.Parameter}>
                                    <StyledTableCell align="left">
                                        {row.Parameter}
                                    </StyledTableCell>
                                    <ValueTableCell align="left">
                                        {row.Values}
                                    </ValueTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </>
    );
};

const CreditCardResponse = (request) => {
    let data = request.request;

    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        if (param.toUpperCase() === 'data not found'.toUpperCase()) return true;
        if (param.toUpperCase() === 'Paramnotmatched'.toUpperCase())
            return true;

        return false;
    };

    let rows = [];

    if (!isBlank(data.Status)) rows.push(Data('Status', data.Status));

    if (!isBlank(data.TransactionID))
        rows.push(Data('TxnID', data.TransactionID));

    if (!isBlank(data.RefrenceID))
        rows.push(Data('OperatorRefNo', data.RefrenceID));

    if (!isBlank(data.ConsumerNumber))
        rows.push(Data('Number', data.ConsumerNumber));

    if (!isBlank(data.OpeningBalance.toString()))
        rows.push(Data('Op.Bal', data.OpeningBalance.toString()));

    if (!isBlank(data.Amount.toString()))
        rows.push(Data('Amount', data.Amount.toString()));

    if (!isBlank(data.Commission.toString()))
        rows.push(Data('Comm.', data.Commission.toString()));

    if (!isBlank(data.ClosingBalance.toString()))
        rows.push(Data('Cl.Bal', data.ClosingBalance.toString()));

    function Data(Parameter, Values) {
        return { Parameter, Values };
    }

    const BBPSAssuredImage = () => {
        return (
            <img
                src={BBPSAssured_LOGO}
                height={200}
                width={200}
                style={{ float: 'right' }}
                alt="BBPS"
            />
        );
    };

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    {data.IsBBPS && (
                        <div
                            align="center"
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }}
                        >
                            <BBPSAssuredImage />
                        </div>
                    )}
                </Table>
            </TableContainer>
        </Grid>
    );
};

const CIBILScoreResponse = ({ request }) => {
    let data = request;
    const isBlank = (param) => {
        if (param === undefined) return true;
        if (param === null) return true;
        if (param === '') return true;
        if (param.toUpperCase() === 'data not found'.toUpperCase()) return true;
        if (param.toUpperCase() === 'Paramnotmatched'.toUpperCase())
            return true;

        return false;
    };

    let rows = [];

    const safeToString = (value) => {
        return value !== undefined && value !== null ? value.toString() : '';
    };

    if (!isBlank(safeToString(data?.Status)))
        rows.push(Data('Status :', safeToString(data?.Status)));

    if (!isBlank(safeToString(data.RefrenceID)))
        rows.push(Data('Reference ID :', safeToString(data.RefrenceID)));

    if (!isBlank(safeToString(data.ConsumerNumber)))
        rows.push(Data('Consumer Number :', safeToString(data.ConsumerNumber)));

    if (!isBlank(safeToString(data.Message)))
        rows.push(Data('Message :', safeToString(data.Message)));

    if (!isBlank(safeToString(data.CIBILData)))
        rows.push(Data('CIBIL Data :', safeToString(data.CIBILData)));

    function Data(Parameter, Values) {
        return { Parameter, Values };
    }


    const BBPSAssuredImage = () => {
        return (
            <img
                src={BBPSAssured_LOGO}
                height={200}
                width={200}
                style={{ float: 'right' }}
                alt="BBPS"
            />
        );
    };

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.Parameter}>
                                <StyledTableCell align="left">
                                    {row.Parameter}
                                </StyledTableCell>
                                <ValueTableCell align="left">
                                    {row.Values}
                                </ValueTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    {data.IsBBPS && (
                        <div
                            align="center"
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }}
                        >
                            <BBPSAssuredImage />
                        </div>
                    )}
                </Table>
            </TableContainer>
        </Grid>
    );
};